import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=3a22577c&scoped=true"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=3a22577c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22577c",
  null
  
)

export default component.exports